export default __webpack_public_path__ + "static/media/aaditi.d2fddd1c.jpeg";